export const sharedQueries = {
  base: ['shared'] as const,

  unit: (id: number | undefined) =>
    [...sharedQueries.base, 'unit', id] as const,
};
